import React, { useCallback, useEffect, useState } from 'react';
import { Button, Col, Form, Spinner } from 'react-bootstrap';
import { FormField } from './FormField';
import { useEscCallback } from './utils';

import './form-field.css';
import { validateField } from '../../../util';

export function FormEditField(props) {
    const { field, defaultValue, submitting, onSubmit, onCancel, schema, errors, clearErrors, ...otherProps } = props;
    const [value, setValue] = useState(defaultValue || '');
    const [fieldErrors, setFieldErrors] = useState(errors);
    const saveBtnDisabled = submitting || value === (defaultValue || '') || fieldErrors;

    useEffect(() => {
        setFieldErrors(errors);
        return () => setFieldErrors(null);
    }, [errors]);

    const handleCancelClick = useCallback(
        (e) => {
            if (onCancel) onCancel(e, field);
        },
        [onCancel, field]
    );
    const handleFieldChange = useCallback(
        (val) => {
            setValue(val);
            if (errors) clearErrors();
            const errMess = validateField({ field, value: val });
            if (fieldErrors || (!fieldErrors && errMess)) setFieldErrors(errMess);
        },
        [errors, clearErrors, field, fieldErrors]
    );
    const handleSubmit = useCallback(
        (e) => {
            e.preventDefault();
            if (onSubmit) onSubmit(e, field, value);
        },
        [onSubmit, field, value]
    );

    useEscCallback(handleCancelClick);

    return (
        <Form onSubmit={handleSubmit} noValidate>
            <Form.Row>
                <div className="form-field__group col">
                    <FormField
                        {...otherProps}
                        field={field}
                        value={value}
                        onChange={handleFieldChange}
                        errors={fieldErrors}
                        autoFocus
                    />
                </div>
            </Form.Row>
            <Form.Row className="mt-3">
                <Col>
                    <Button variant="outline-primary" type="submit" className="px-5 w-100" disabled={saveBtnDisabled}>
                        {submitting && (
                            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                        )}
                        <span>Сохранить</span>
                    </Button>
                </Col>
                <Col>
                    <Button
                        variant="outline-secondary"
                        type="reset"
                        className="px-5 w-100"
                        onClick={handleCancelClick}
                        disabled={submitting}
                    >
                        Отмена
                    </Button>
                </Col>
            </Form.Row>
        </Form>
    );
}
